<pda-base>
    <div class="pda-staff full-height">
        <div class="pda-staff-section">
            <div class="pda-staff-section-title-container">
                <h2 class="pda-title">
                    <span class="pda-title-1 text-shadow">Nuestro</span>
                    <span class="pda-title-2 text-shadow">&nbsp;Staff</span>
                </h2>
            </div>
            <div class="pda-staff-section-gallery">
                <pda-gallery [config]="config"></pda-gallery>
            </div>
        </div>
    </div>
</pda-base>